import React from "react";
//#region types
import { TableActionButtonProps, TableActionsProps } from "models/propTypes/simpleTableProps";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import RoundButton from "../buttons/roundButton";
import SimpleTooltip from "../tooltips/tooltip";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const TableActionButtonss: React.FC<TableActionsProps> = ({ actions, size }) => {
  return (
    <Grid item container direction={"row"} wrap="nowrap" columnGap={1} width={"fit-content"}>
      {actions.map((action, index) => (
        <Grid item key={index}>
          {action.toolTipText ? (
            <SimpleTooltip text={action.toolTipText}>
              <span>
                <TableActionButton {...action} size={size} />
              </span>
            </SimpleTooltip>
          ) : (
            <TableActionButton {...action} size={size} />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

const TableActionButton: React.FC<TableActionButtonProps & { size?: "small" | "large" }> = ({
  onClickHandler,
  icon,
  size,
}) => {
  return (
    <RoundButton
      className={clsx(cssExports.tableIconButton, size === "small" ? cssExports.sm : "")}
      onClick={onClickHandler}
      displayType={StyleEnums.DisplayType.None}
    >
      <Icon icon={icon} />
    </RoundButton>
  );
};

export default TableActionButtonss;
